<template>
  <div id="app">
    <div v-if="isLandscape" class="horizontal">
      <div class="horizontalText">
        <img src="@/assets/images/loginPage/logo.png" alt="">
      </div>
      <div class="textArea">
        <div class="leftImg">
          <img src="@/assets/images/indexPage/horizontalPhone.png" alt="">
        </div>
        <div class="rightText">
          <p>为更好浏览体验</p>
          <p class="blueText">
            请旋转手机到竖屏模式
          </p>
        </div>
      </div>
    </div>
    <div v-else class="app-scale-root" :class="appScaleModeClass">
      <router-view v-if="!$route.meta.keepAlive" />
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import { isBgmPlaying, toggleBgm } from '@/utils/music'

export default {
  name: 'App',
  data() {
    return {
      // 首屏直接用当前窗口宽度决定 class，避免 computed/响应式导致的首帧闪烁
      appScaleModeClass: window.innerWidth < 740 ? 'use-fluid-size' : 'use-design-size',
      isLandscape: false, // 判断当前是否为横屏
    }
  },
  mounted() {
    const refresh = () => {
      this.appScaleModeClass = window.innerWidth < 740 ? 'use-fluid-size' : 'use-design-size'
    }
    window.addEventListener('resize', refresh)
    this.$once('hook:beforeDestroy', () => window.removeEventListener('resize', refresh))

    // 横屏检测
    this.checkOrientation();  // 组件加载时检查一次
    const mediaQuery = window.matchMedia("(orientation: landscape)");
    mediaQuery.addEventListener('change', this.handleOrientationChange);
    this.$once('hook:beforeDestroy', () => {
      mediaQuery.removeEventListener('change', this.handleOrientationChange);
    })

    // 窗口可见性变化监听 - 页面隐藏时自动播放音乐
    const handleVisibilityChange = () => {
      if (document.hidden && isBgmPlaying()) {
        toggleBgm();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    })
  },
  methods: {
    // 判断当前屏幕方向
    checkOrientation() {
      // 使用matchMedia监听横屏状态
      const mediaQuery = window.matchMedia("(orientation: landscape)");
      this.isLandscape = mediaQuery.matches;
    },
    handleOrientationChange(e) {
      this.isLandscape = e.matches;
    },
  },
  components: {

  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}

.horizontal {
  height: 100vh;
  background: url("@/assets/images/indexPage/horizontalBg.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .horizontalText {
    position: absolute;
    left: 40px;
    top: 5vh;

    img {
      display: block;
      height: 5vh;
      width: auto;
    }
  }
  .textArea {
    display: flex;

    .leftImg {
      margin-right: 40px;

      img {
        height: 100px;
      }
    }
  }

  .rightText {
    text-align: left;
    font-size: 32px;
    font-family: 'FontMedium', sans-serif;
    color: #f5c412;
    display: flex;
    flex-flow: column;
    justify-content: center;

    p {
      padding: 0;
      margin: 0;
    }

    .blueText {
      color: #f5c412;
    }
  }
}
</style>
